import { Box, Container, Skeleton, Stack } from '@mui/material';
import PositiveButton from 'components/cmn/PositiveButton';
import { memo } from 'react';

function SurveyResultPage(): JSX.Element {
  const handleDownload = () => {
    console.log('다운로드');
  };
  const handleExit = () => {
    console.log('종료');
  };
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      <Box sx={{ flex: 1, p: 4, width: '100%' }}>
        <Container maxWidth="xl" sx={{ height: 'calc(100%)' }}>
          <Container
            maxWidth="lg"
            sx={{
              p: 0,
              height: 'calc(100% - 84px)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Stack direction="column" justifyContent="center" alignContent="center" alignItems="center">
              <Stack direction="column" spacing={2} sx={{ width: '100%', p: '24px' }}>
                <Skeleton variant="rectangular" width={550} height={400} />
              </Stack>
            </Stack>
          </Container>
        </Container>
      </Box>
      <Box
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          width: '100%',
          bgcolor: 'background.paper',
          boxShadow: '0px -2px 10px rgba(0, 0, 0, 0.1)',
          py: 2,
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Stack spacing={10} direction="row" justifyContent="center">
          <PositiveButton
            variant="contained"
            onClick={handleDownload}
            sx={{ width: { xs: 130 }, height: 52, typography: 's14w500' }}
            title="다운로드"
          />
          <PositiveButton
            variant="contained"
            onClick={handleExit}
            sx={{ width: { xs: 130 }, height: 52, typography: 's14w500' }}
            title="종료"
          />
        </Stack>
      </Box>
    </Box>
  );
}

export default memo(SurveyResultPage);
